// Bump the caller's last_read_at on the given channel. Called when the user
// switches into a channel and when a fresh message arrives in the active
// channel.
import { getSDK } from '../sdk.js'

export const markRead = async function (channelId) {
  if (!channelId) return
  const root = this.state.root
  const me = root.currentUserEmail
  const now = new Date().toISOString()

  // Optimistic local update first.
  root.update({
    channelMembers: (root.channelMembers || []).map(m =>
      m.channel_id === channelId && m.member_email === me
        ? { ...m, last_read_at: now }
        : m
    )
  })

  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat.members markRead
    await getSDK().execute('workspaceProject.chat.members', 'markRead', {
      channelId,
      userId: me,
      lastReadAt: now
    })
  } catch (e) {
    console.error('[markRead]', e?.message || e)
  }
}
